<div class="iq-pricing-table ">
  <div class="pricing-header">
    <ng-content select="[cardHeader]"></ng-content>
  </div>
  <ul class="">
    <ng-content select="[cardBody]"></ng-content>
  </ul>
  <ng-content select="[cardFooter]"></ng-content>
</div>
